module.exports = __webpack_public_path__ + "img/花草_03.00df44d7.png";